import React from 'react';
import { Icon, SpeedDial, SpeedDialAction } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableColumns } from '@fortawesome/free-solid-svg-icons';

interface ErrorMessageProps {
  colorBg?: string;
  colorBgHover?: string;
  colorIcon?: string;
  sidebarIsLeft: boolean;
  sizes: number[];
  onSetSizes: (sizes: number[]) => void;
  setSidebarLeft: (isLeft: boolean) => void;
}

const DashboardOptionDial: React.FC<ErrorMessageProps> = ({
  colorBg,
  colorBgHover,
  colorIcon,
  sidebarIsLeft, 
  sizes,
  onSetSizes,
  setSidebarLeft: onSetSidebarLocation
}) => {

  const actions = [
    { icon: <Icon>align_horizontal_left</Icon>, name: 'Toon plannen links' },
    { icon: <Icon>align_horizontal_right</Icon>, name: 'Toon plannen rechts' },
    { icon: <Icon>map</Icon>, name: 'Toon alleen de kaart' },
    { icon: <Icon>list</Icon>, name: 'Toon alleen de plannen' },
    { icon: <FontAwesomeIcon icon={faTableColumns} />, name: 'Default' },
  ];

  const onClickSideBarOptions = (value: any) => { 
    switch (value) {
      case 'Toon plannen rechts':
        onSetSidebarLocation(false);
        onSetSizes([50, 50]);
        break;
      case 'Toon plannen links':
        onSetSidebarLocation(true);
        onSetSizes([50, 50]);
        break;
      case 'Toon alleen de kaart':
        if (sidebarIsLeft) {
          onSetSizes([0, 100]);
        }
        else {
          onSetSizes([100, 0]);
        }
        break;
      case 'Toon alleen de plannen':
        if (sidebarIsLeft) {
          onSetSizes([100, 0]);
        } else {
          onSetSizes([0, 100]);
        }
        break;
      case 'Default':
        onSetSizes([50, 50]);
        break;
      default:
        break;
    }
  };

  return (
    <SpeedDial
      ariaLabel="Kies een indeling van het scherm"
      sx={{ position: "absolute", bottom: -30, left: 15, zIndex: 1190 }}
      icon={<FontAwesomeIcon icon={faTableColumns} />}
      FabProps={{
        sx: {
          ...(colorBg && { backgroundColor: colorBg }), // Apply only if colorBg is set
          ...(colorBgHover && { "&:hover": { backgroundColor: colorBgHover } }), // Apply hover only if colorBgHover is set
          ...(colorIcon && { color: colorIcon }), // Apply only if colorIcon is set
        },
      }}
      direction="right"
    >
      {actions
      .filter((action) => {
        const isFullScreen = sizes.includes(100); // Check if either sizes[0] or sizes[1] is 100
        if (isFullScreen) return true; // If fullscreen, don't exclude any actions

        return !(
          (sidebarIsLeft && action.name === "Toon plannen links") ||
          (!sidebarIsLeft && action.name === "Toon plannen rechts")
        );
      })
      .map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={() => onClickSideBarOptions(action.name)}
        />
      ))}

    </SpeedDial>
  )
};

export default DashboardOptionDial;
